module.exports = __webpack_public_path__ + "img/logout.a3021bf7.svg";